import parser from 'html-react-parser';
import React from 'react';
import { cessationPlanText } from '../utils/cessationPlan';

const CessationPlan: React.FC = () => {
    return (
        <div className="pt-4">
            <p className="mt-6 mb-6 w-full text-center sm:text-center md:text-left page_title uppercase">
                Cessation Plan
            </p>
            <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto mt-4">
                <div className="px-4 py-4">
                    {cessationPlanText.map((c, index) => (
                        <div key={`${c.title}_${index}`}>
                            <p className="text-base py-2 SourceSansPro-SemiBold underline uppercase text-[#142C53]">
                                {c.title && parser(c.title)}
                            </p>
                            {c.child.map((c1, index1) => (
                                <div key={`${index}_${index1}_${c1.title}`}>
                                    <p className="text-base py-1 text-justify sm:text-justify md:text-left WorkSans">
                                        {c1.title && parser(c1.title)}
                                    </p>
                                    <ul className="list-decimal pl-8 font-[Lato] ">
                                        {c1.child.map((c2, index2) => (
                                            <li key={`${index}_${index1}_${index2}`} className="text-sm my-1">
                                                {c2 && parser(c2)}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CessationPlan;
